import React, { ReactNode } from 'react';
import {
  Headline,
  HeadlineProps,
  LinkButton,
  LinkButtonProps,
} from '@sato/components';
import { twMerge } from 'tailwind-merge';

import { Link } from './common/Link';

export interface SectionTitle {
  children: ReactNode;
  className?: string;
  level?: HeadlineProps['level'];
  buttonProps?: LinkButtonProps<typeof Link>;
  bottomBorder?: boolean;
}

export const SectionTitle = ({
  children,
  level = 2,
  className,
  buttonProps,
  bottomBorder = !!buttonProps,
}: SectionTitle) => {
  return (
    <div
      className={twMerge(
        'mb-3 flex items-center gap-3 py-3 md:py-5 mdDown:flex-wrap',
        bottomBorder && 'border-b',
        className
      )}
    >
      <Headline level={level} className="flex-1">
        {children}
      </Headline>

      {buttonProps && (
        <LinkButton variant="text" linkComponent={Link} {...buttonProps} />
      )}
    </div>
  );
};
